import React from 'react';
import { Box, Skeleton } from '@mui/material';

const SKELETON_ROWS = 14;

const SkeletonBar = ({ variant = 'md' }) => (
  <span className={`skeleton-bar skeleton-bar--${variant}`} />
);

const SkeletonRow = ({ index }) => (
  <tr>
    <td><SkeletonBar variant={index % 3 === 0 ? 'link' : 'sm'} /></td>
    <td><SkeletonBar variant="lg" /></td>
    <td><span className="skeleton-pill" /></td>
    <td><SkeletonBar variant="sm" /></td>
    <td><SkeletonBar variant="md" /></td>
    <td><SkeletonBar variant="md" /></td>
    <td><SkeletonBar variant="sm" /></td>
    <td><SkeletonBar variant="sm" /></td>
    <td><SkeletonBar variant="md" /></td>
    <td><SkeletonBar variant="lg" /></td>
    <td><SkeletonBar variant="md" /></td>
    {/* <td><SkeletonBar variant="md" /></td>
    <td><SkeletonBar variant="md" /></td> */}
  </tr>
);

const ForecastTableSkeleton = ({ rows = SKELETON_ROWS }) => (
  <div className="demand-forecasting__table-wrap jklc-forecast-skeleton">
    <table className="demand-forecasting__table">
      <thead>
        <tr>
          <th rowSpan={2} style={{ width: '110px' }}>Dealer Code</th>
          <th rowSpan={2} style={{ width: '170px' }}>Dealer Name</th>
          <th rowSpan={2} style={{ width: '110px' }}>Dealer Status</th>
          <th rowSpan={2} style={{ width: '90px' }}>Zone</th>
          <th rowSpan={2} style={{ width: '90px' }}>Region</th>
          <th rowSpan={2} style={{ width: '100px' }}>District</th>
          <th rowSpan={2} style={{ width: '110px' }}>District Code</th>
          <th rowSpan={2} style={{ width: '90px' }}>Tehsil</th>
          <th rowSpan={2} style={{ width: '120px' }}>Dealer Segment</th>
          <th colSpan={2} className="header-group">EPM</th>
          {/* <th colSpan={2} className="header-group">SAP</th> */}
        </tr>
        <tr>
          <th style={{ width: '130px' }}>Account Owner</th>
          <th style={{ width: '130px' }}>Reports To</th>
          {/* <th style={{ width: '130px' }}>Account Owner</th>
          <th style={{ width: '130px' }}>Reports To</th> */}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: rows }, (_, index) => (
          <SkeletonRow key={index} index={index} />
        ))}
      </tbody>
    </table>
  </div>
);

const AggregatedPanelTableSkeleton = ({ rowCount = 8, maxHeight = 'calc(100vh - 470px)' }) => (
  <div
    className="jklc-table-wrapper monthly-recon-table jklc-forecast-skeleton"
    style={{ maxHeight, overflow: 'hidden' }}
  >
    <div className="demand-forecasting__table-wrap" style={{ border: 'none', maxHeight: 'none' }}>
      <table className="demand-forecasting__table" style={{ minWidth: '100%' }}>
        <thead>
          <tr>
            {['Label', 'MTD', 'Forecast', 'Variance', 'Var %'].map((label) => (
              <th key={label}>{label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rowCount }, (_, index) => (
            <tr key={index}>
              {Array.from({ length: 5 }, (_, col) => (
                <td key={col}>
                  <SkeletonBar variant={col === 0 ? 'md' : 'sm'} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export const SalesForecastTableSkeleton = ({ rows = SKELETON_ROWS } = {}) => (
  <ForecastTableSkeleton rows={rows} />
);

/** Column layout mirrors getlightgbmwmapesummary row_header (category + month grid). */
export const WMAPE_SUMMARY_SKELETON_HEADERS = [
  { key: 'category', label: 'WMAPE' },
  { key: 'Aug-26', label: 'Aug-26' },
  { key: 'Jul-26', label: 'Jul-26' },
  { key: 'Jun-26', label: 'Jun-26' },
  { key: 'May-26', label: 'May-26' },
  { key: 'Apr-26', label: 'Apr-26' },
  { key: 'Mar-26', label: 'Mar-26' },
  { key: 'Feb-26', label: 'Feb-26' },
  { key: 'Jan-26', label: 'Jan-26' },
  { key: 'Dec-25', label: 'Dec-25' },
  { key: 'Nov-25', label: 'Nov-25' },
  { key: 'Oct-25', label: 'Oct-25' },
  { key: 'Sep-25', label: 'Sep-25' },
  { key: 'Aug-25', label: 'Aug-25' },
  { key: 'Jul-25', label: 'Jul-25' },
  { key: 'Jun-25', label: 'Jun-25' },
  { key: 'May-25', label: 'May-25' },
  { key: 'Apr-25', label: 'Apr-25' },
  { key: 'Mar-25', label: 'Mar-25' },
  { key: 'Feb-25', label: 'Feb-25' },
  { key: 'Jan-25', label: 'Jan-25' },
  { key: 'Dec-24', label: 'Dec-24' },
  { key: 'Nov-24', label: 'Nov-24' },
  { key: 'Oct-24', label: 'Oct-24' },
  { key: 'Sep-24', label: 'Sep-24' },
  { key: 'Aug-24', label: 'Aug-24' },
  { key: 'Jul-24', label: 'Jul-24' },
  { key: 'Jun-24', label: 'Jun-24' },
  { key: 'May-24', label: 'May-24' },
  { key: 'Apr-24', label: 'Apr-24' },
];

const WMAPE_SUMMARY_SKELETON_ROWS = 11;

const WmapeSummarySkeletonRow = ({ index }) => (
  <tr>
    {WMAPE_SUMMARY_SKELETON_HEADERS.map((col, colIndex) => (
      <td key={col.key}>
        <SkeletonBar variant={colIndex === 0 ? (index % 2 === 0 ? 'md' : 'link') : 'sm'} />
      </td>
    ))}
  </tr>
);

const WmapeSummaryTableSkeletonInner = ({ rows = WMAPE_SUMMARY_SKELETON_ROWS }) => (
  <div className="demand-forecasting__table-wrap jklc-forecast-skeleton jklc-wmape-skeleton">
    <div
      className="jklc-table-wrapper forecast-report-table wmape-summary-table"
      style={{ overflowX: 'auto', maxWidth: '100%' }}
    >
      <table className="demand-forecasting__table" style={{ minWidth: WMAPE_SUMMARY_SKELETON_HEADERS.length * 96 }}>
        <thead>
          <tr>
            {WMAPE_SUMMARY_SKELETON_HEADERS.map((h) => (
              <th
                key={h.key}
                style={{
                  width: h.key === 'category' ? 180 : 96,
                  minWidth: h.key === 'category' ? 180 : 96,
                  whiteSpace: 'nowrap',
                }}
              >
                {h.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }, (_, index) => (
            <WmapeSummarySkeletonRow key={index} index={index} />
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export const WmapeSummaryTableSkeleton = ({ rows = WMAPE_SUMMARY_SKELETON_ROWS } = {}) => (
  <WmapeSummaryTableSkeletonInner rows={rows} />
);

export const StatMtdChartAreaSkeleton = () => (
  <div className="jklc-forecast-skeleton jklc-forecast-skeleton--chart">
    <span className="skeleton-bar skeleton-bar--lg" style={{ display: 'block', height: 280, borderRadius: 4 }} />
  </div>
);

/** Dealer Segment / Dealer Risk — two aggregated table panels side by side. */
export const AggregatedForecastPanelsSkeleton = ({ variant = 'segment' }) => {
  const titles = variant === 'risk'
    ? ['P90 (Low Risk)', 'P70 (Medium Risk)']
    : ['Royal Dealer', 'Elite Dealer'];

  return (
    <Box
      className="esf-table-wrapper aggregated-forecast-panels-skeleton"
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: '1em',
        alignItems: 'stretch',
        width: '100%',
        minHeight: 320,
        overflowX: 'auto',
      }}
    >
      {titles.map((title) => (
        <Box
          key={title}
          className="esf-table"
          sx={{
            flex: '1 1 calc(50% - 0.5em)',
            width: 'calc(50% - 0.5em)',
            minWidth: 520,
          }}
        >
          <Box sx={{ p: 1, bgcolor: '#fff', borderRadius: 2, height: '100%' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                height: 30,
                mb: 0.75,
              }}
            >
              <Skeleton variant="text" width={Math.min(title.length * 8, 140)} height={24} />
              <Skeleton variant="rounded" width={30} height={30} />
            </Box>
            <AggregatedPanelTableSkeleton />
          </Box>
        </Box>
      ))}
    </Box>
  );
};
